import React from 'react'
import AppProgress from './AppProgress'
import { LoanOfficerNavCard } from './LoanOfficerNavCard'
import { FEATURE_FLAG_TYPES } from '@mortgage-pos/data'
import { useVariation } from '@mortgage-pos/ui/services/featureFlags'
import { environment } from '@mortgage-pos/ui/env'
import { logoMap } from '@mortgage-pos/ui/utils/customizationHelpers'

export default function AppSidebar() {
  const showSidebarLOCard = useVariation(
    FEATURE_FLAG_TYPES.SHOW_SIDEBAR_LO_CARD
  )

  const logo = logoMap(
    ['sage', 'sage-home-loans'].includes(environment.productName) ? 'white' : ''
  )

  const additionalLogoStyles: React.CSSProperties =
    environment.productName === 'sage-home-loans'
      ? {
          maxHeight: '70px',
        }
      : {}

  return (
    <div className="app-sidebar">
      <nav aria-label="App progress">
        <div className="app-sidebar__content">
          <img
            className="app-sidebar__logo"
            src={logo}
            alt={`${environment.productName} Logo`}
            style={additionalLogoStyles}
          />
          <AppProgress />
        </div>

        {showSidebarLOCard ? <LoanOfficerNavCard /> : <></>}
      </nav>
    </div>
  )
}
